import { useMutation, useQueryClient } from "@tanstack/react-query";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerCatalog } from "@/lib/query/core/invalidation";
import { queryKeys } from "@/lib/query/core/query-keys";

type DeleteProductInput = {
  storeSlug: string;
  productId: string;
};

export function useDeleteProductMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: ({ productId }: DeleteProductInput) =>
      apiJsonClient<unknown>(endpoints.seller.productById(productId), {
        method: "DELETE",
      }),
    onSuccess: async (_data, variables) => {
      await invalidateSellerCatalog(queryClient, variables.storeSlug);
      await queryClient.removeQueries({
        queryKey: queryKeys.seller.productById(variables.storeSlug, variables.productId),
        exact: true,
      });
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
